// extracted by extract-css-chunks-webpack-plugin
module.exports = {"history":"history_2Jzwr","history_wrap":"history_wrap_3wn5k","swiper":"swiper_3znH8"};